import { EcommerceHead } from './EcommerceHead'

import { usePlanDataLayerObject } from '../../../hooks'

export const PlanIndexHead = () => {
  const dataLayerObject = usePlanDataLayerObject()

  return dataLayerObject && <EcommerceHead dataLayerObject={dataLayerObject} />
}
